import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import {
  StaffLegalRepresentativeRequest,
  StaffLegalRepresentativeResponse,
  StaffLegalRepresentativesService,
} from "lib-klab-sdks";
import { LegalRepresentativesPort } from "../../../app/ports/organization/legal-representatives.port";
import {
  LegalRepresentative,
  LegalRepresentativeRequest,
} from "../../../domain/models/organization/legal-representative.model";

@Injectable({ providedIn: "root" })
export class LegalRepresentativesPortAdapter implements LegalRepresentativesPort {
  constructor(private readonly api: StaffLegalRepresentativesService) {}

  list(filters?: {
    companyId?: number;
    status?: string;
  }): Observable<LegalRepresentative[]> {
    return this.api
      .list(filters)
      .pipe(map((items) => items.map(mapRepresentative)));
  }

  getById(id: number): Observable<LegalRepresentative> {
    return this.api.getById(id).pipe(map(mapRepresentative));
  }

  create(request: LegalRepresentativeRequest): Observable<LegalRepresentative> {
    return this.api.create(mapRequest(request)).pipe(map(mapRepresentative));
  }

  update(
    id: number,
    request: LegalRepresentativeRequest,
  ): Observable<LegalRepresentative> {
    return this.api
      .update(id, mapRequest(request))
      .pipe(map(mapRepresentative));
  }

  setStatus(id: number, active: boolean): Observable<LegalRepresentative> {
    return this.api.setStatus(id, active).pipe(map(mapRepresentative));
  }

  delete(id: number): Observable<void> {
    return this.api.delete(id);
  }
}

function mapRepresentative(
  item: StaffLegalRepresentativeResponse,
): LegalRepresentative {
  return {
    id: item.legalRepresentativeId,
    companyId: item.companyId,
    firstName: item.firstName,
    lastName: item.lastName,
    documentType: item.documentType,
    documentNumber: item.documentNumber,
    phoneCountryCode: item.phoneCountryCode,
    phone: item.phone,
    nationality: item.nationality,
    departmentId: item.departmentId,
    email: item.email,
    status: item.status,
  };
}

function mapRequest(
  request: LegalRepresentativeRequest,
): StaffLegalRepresentativeRequest {
  return { ...request };
}
